import { css } from 'styled-components';

export const transactionTableBaseStyles = css`
    .subject-container {
        h2 {
            padding: 1rem 0 0.25rem 1.5rem;
            font-size: 1.15rem;
            font-weight: 600;
            text-transform: capitalize;
            margin-bottom: 0;
        }

        .date-container {
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            border-top: ${(props) => props.theme.DefaultBorder};

            .vertical-date-container {
                width: 5rem;
                padding-top: 0.75rem;
            }
        }

        .billinginfo-line {
            display: block;
            margin-bottom: 2rem;

            .billinginfo-header {
                padding: 0 1rem 0.75rem 2rem;
                border-bottom: ${(props) => props.theme.DefaultBorder};
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .billinginfo-header-left {
                    padding-right: 2rem;
                }
                .billinginfo-header-middle {
                    flex: 1 1 0;
                    h2 {
                        padding: 0;
                        margin: 0;
                    }
                }
                .billinginfo-header-right {
                    padding-right: 1rem;
                }
            }
        }

        .transactions-container {
            flex: 1 1 0;
            border-left: ${(props) => props.theme.DefaultBorder};
            padding: 0;
            min-height: 4rem;

            .ant-table {
                table {
                    border-collapse: collapse;
                    min-height: 5rem;
                    tr {
                        td {
                            vertical-align: top;
                            padding: 0;
                            border-top: ${(props) => props.theme.LighterBorder};

                            &.cell-border-left {
                                border-left: ${(props) => props.theme.DefaultBorder};
                            }
                            &.cell-border-right {
                                border-right: ${(props) => props.theme.DefaultBorder};
                            }

                            &.ant-table-selection-column {
                                vertical-align: middle;
                                padding: 0 1rem 0 1.5rem;
                                cursor: default;

                                .selection-wrapper {
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                }
                            }

                            .transaction-left {
                                padding: 0.75rem;
                                small {
                                    display: block;
                                    line-height: 1.5;
                                    text-transform: uppercase;
                                }
                                .transaction-model {
                                    text-transform: uppercase;
                                }
                            }
                            .transaction-middle {
                                padding: 0.75rem;
                            }
                            .transaction-right {
                                min-width: 170px;
                                display: flex;
                                justify-content: flex-end;
                                align-items: center;
                                text-align: right;

                                .transaction-fee {
                                    padding: 0.5rem 0.75rem 0.5rem 1.5rem;
                                    min-height: 4rem;
                                    display: flex;
                                    flex-direction: column;
                                    align-items: flex-end;
                                    justify-content: space-between;
                                    /* min-width: 15rem; */
                                    height: 100%;
                                    white-space: nowrap;

                                    small {
                                        display: block;
                                    }

                                    .total-fee {
                                        font-size: 1rem;
                                        font-weight: bold;

                                        .original-amount {
                                            font-size: ${(props) => props.theme.FontSizeSm};
                                            font-weight: normal;
                                        }
                                    }
                                    .statement-fee {
                                        font-weight: bold;
                                    }
                                    .muted-job-fee {
                                        font-size: ${(props) => props.theme.FontSizeSm};
                                        font-weight: normal;
                                        color: ${(props) => props.theme.TextColorMuted};
                                    }
                                }

                                .edit-button {
                                    cursor: pointer;
                                    min-width: 50px;
                                }

                                &.commission-row,
                                &.advance-row {
                                    .transaction-fee {
                                        padding: 0.25rem 0.75rem 0.25rem 0.5rem;
                                        min-height: 2.5rem;
                                    }
                                    .edit-button {
                                        margin-top: -2px;
                                        background-color: white;
                                        min-height: 2.5rem;
                                    }
                                }
                            }

                            /* WHEN MORE CELLS ARE IN THE SAME CELL */
                            .transaction-meta-wrapper {
                                padding: 0.75rem;
                                .transaction-left {
                                    padding: 0;
                                }
                                .transaction-middle {
                                    padding: 0;
                                }
                                .transaction-right {
                                    padding: 0;
                                }
                            }
                        }

                        &.cancelled {
                            td {
                                .transaction-title,
                                .transaction-left,
                                .total-fee {
                                    ${(props) => props.theme.RedLineThrough(1)};
                                }
                            }
                        }
                        &.not-confirmed {
                            td {
                                opacity: 0.5;
                            }
                        }

                        &.ant-table-row-selected > td {
                            .transaction-date {
                                &.commission-row,
                                &.advance-row {
                                    background-color: ${(props) => props.theme.HoverablesBackground};
                                }
                            }
                            .transaction-right {
                                &.commission-row,
                                &.advance-row {
                                    .edit-button {
                                        background-color: ${(props) => props.theme.HoverablesBackground};
                                    }
                                }
                            }
                        }

                        :nth-of-type(1) {
                            td {
                                border-top: none;
                            }
                        }
                    }
                }
            }

            p {
                font-size: 1rem;
                margin-bottom: 0;
            }
        }
    }

    .transactions-list-for-event-drawer {
        h1 {
            padding: 1rem 0 0.5rem 1.25rem;
            font-size: 1.25rem;
            font-weight: 600;
            text-transform: capitalize;
            margin: 0;
        }

        .subject-container {
            h2 {
                font-size: 1.1rem;
            }

            .transactions-container {
                table {
                    tr {
                        td {
                            .transaction-left {
                                .transaction-title {
                                    small {
                                        display: inline-block;
                                        padding-bottom: 0.15rem;
                                        padding-right: 0.2rem;
                                        vertical-align: middle;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .actions-on-selected-lines {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #fff;

        .selected-lines-counter {
            text-transform: uppercase;
            padding: 1rem;
        }
        .actions-on-selected-lines-content {
            flex: 1 1 0;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 2rem;
            padding: 1rem;
        }
    }
`;

export const transactionContentBaseStyles = css`
    .bold-text {
        font-weight: bold;
    }
    .tx-content {
        margin-bottom: 1rem;
        .contact-row {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .select-all {
                .check-icon {
                    margin: auto 5px auto 0;
                }
                display: flex;
                flex-direction: row;
                color: ${(props) => props.theme.PrimaryColor};
                margin-left: 10px;
                cursor: pointer;
                user-select: none;
            }
        }
        .tx-details {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 10px 0;
            border-bottom: ${(props) => props.theme.DarkerBorder};
        }
    }
`;
